import { CalendarDateRangePicker } from "./date-range-picker";
import { cn } from "@/lib/utils";
import React from "react";
import ChartOptionsSelector from "@/chartOptions/chartOptionsSelector";

interface HeaderProps {
  name?: string;
  showDatePicker?: boolean;
  showChartOptions?: boolean;
  className?: string;
}

export const Header = ({
  name,
  className,
  showDatePicker = true,
  showChartOptions = true
}: HeaderProps) => {
  return (
    <div className="flex col-span-full flex-col lg:flex-row w-full lg:space-x-2">
      <div className={cn("text-3xl font-semibold flex-1", className)}>
        {name}
      </div>
      {
        (showDatePicker || showChartOptions) && (
          <div className="flex flex-col lg:flex-row w-full gap-2 justify-end">
            {
              showChartOptions && (
                <ChartOptionsSelector />
              )
            }
            {
              showDatePicker && (
                <CalendarDateRangePicker align="end"/>
              )
            }
          </div>
        )
      }
    </div>
  );
};
